import React, { useState, useEffect } from "react";

export const ButtonList = (props) => {
  const [curPDF, setCurPDF] = useState(null);

  const [isChromeMobile, setIsChromeMobile] = useState(false);

  useEffect(() => {
    let isMobile = !!navigator.userAgent.match(
      /Android|webOS|iPhone|iPod|Blackberry/i
    );
    let isChrome = !!navigator.userAgent.match(/Chrome/i);
    setIsChromeMobile(isChrome && isMobile);


    let isWebkit = !!navigator.userAgent.match(/AppleWebKit/i);
    setIsChromeMobile((isChrome && isMobile) || isWebkit);
  }, []);

  useEffect(() => {
    const reports = props.reports;
    if (reports.length === 1) {
      setCurPDF(reports[0]);
    } else {
      setCurPDF(null);
    }
  }, [props.reports, setCurPDF]);

  return (
    <>
      {props.reports.length > 1 ? (
        <div id="multipleCOA">
          The Batch ID you've selected has multiple reports. Please select the
          one you'd like to see:
        </div>
      ) : null}
      {props.reports.length > 1 &&
        props.reports.map((report, i) => (
          <button
            key={i}
            id={i}
            title={report.name}
            onClick={() => setCurPDF(report)}
            style={{ color: "white", margin: "8px", width: "225px" }}
          >
            {report.name}
          </button>
        ))}
      <br />
      {curPDF && props.reports.length > 0 && (
        <>
          <iframe
            key={curPDF.name}
            src={
              isChromeMobile
                ? `https://docs.google.com/viewerng/viewer?url=${curPDF.url}&embedded=true`
                : curPDF.url
            }
            width="1000px"
            height="500px"
            title={curPDF.name}
            style={{margin: "10px"}}
          />
        </>
      )}
    </>
  );
};
